import React from 'react';
import { HtmlElementDefaults } from '../../type/HtmlElementDefaults';
import clsx from 'clsx';
import './XSMask.css';

type Input = HtmlElementDefaults & {
    unmount?: boolean;
};

export function XSMask(input: Input) {
    const { className, children, unmount } = input;

    return <div className={clsx('XSMask', className, { unmount })}>{children}</div>;
}
